export const exportReviewColumns: any = [
  {
    title: 'select-all-btn',
    active: false,
    col: 'select-btn',
    cssWidth: '130px',
  },
  {
    title: 'PIES Deltas',
    sortable: false,
    active: false,
    col: 'piesDeltas',
    textSize: 'xl',
    cssWidth: '130px',
  },
  {
    title: 'Part no.',
    sortable: true,
    sort: 'desc',
    active: false,
    link: true,
    truncate: true,
    col: 'partNumber',
    cssWidth: '10%',
  },
  {
    title: 'Terminology',
    sortable: true,
    sort: 'desc',
    active: false,
    truncate: true,
    col: 'terminology',
    cssWidth: '10%',
  },
  {
    title: 'Product description',
    sortable: true,
    sort: 'desc',
    active: false,
    truncate: true,
    col: 'productDescription'
  },
  {
    title: 'Fitments',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'fitments',
    linkEmptyUnderlineOnHover: true,
    link: true,
    permissions: ['admin', 'fitments'],
    cssWidth: '90px',
  },
  {
    title: 'New fitments',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'newFitments',
    cssWidth: '90px',
  }
];
